define('drops/calendar/daysofmonthcalendar',[
    'jquery',
    'underscore',
    'globalize',
    'moment',
    'lq/eventSource',
    'tpl!drops/calendar/daysofmonthcalendar.html',
    'lq/html'
], function ($, _, globalize, moment, EventSource, template, html) {
    'use strict';

    var defaults = {
        standalone: false,
        showWeekdayHeaders: false,
        weekdayHeadersFormat: 'd',
        titleFormat: 'MMMM yyyy',
        languageISOCode: null
    };

    var DaysOfMonthCalendar = function (options) {
        EventSource.call(this, ['Navigated', 'Clicked']);

        this.options = $.extend({}, defaults, options);
        this.selectedDate = null;

        this.$element = $(template());

        var self = this;
        this.$element.find('.previous-page')
            .on('click', function() {
                self.previous();
            });
        this.$element.find('.next-page')
            .on('click', function () {
                self.next();
            });

        this.$title = this.$element.find('.date-as-title');
        this.$days =  this.$element.find('.calendar-days');
        this.$weekdayHeaders = _.map(_.range(1, 8), function () {
            return $('<div />');
        });

        this.$days.append($('<div />')
            .addClass('weekday-headers')
            .append(this.$weekdayHeaders));

        if (!this.options.standalone) {
            this.$element.addClass('no-navigation');
            this.$title.addClass('always-visible');
        }

        this.updateWeekdayHeaders();
        this.toggleWeekdayHeaders();
    };

    DaysOfMonthCalendar.prototype.updateWeekdayHeaders = function () {
        var self = this;
        _.each(this.$weekdayHeaders, function ($weekdayHeader, i) {
            var date = moment().day(i + 1); // by default the first day of week is Sunday, but we start on Monday
            var name = globalize.format(
                date.toDate(),
                self.options.weekdayHeadersFormat,
                self.options.languageISOCode ? self.options.languageISOCode : undefined);
            $weekdayHeader.text(name);
        });
    };

    DaysOfMonthCalendar.prototype.toggleWeekdayHeaders = function () {
        if (this.options.showWeekdayHeaders)
            this.$element.removeClass('no-weekday-headers');
        else
            this.$element.addClass('no-weekday-headers');
    };

    DaysOfMonthCalendar.prototype.previous = function() {
        this.open(moment(this.date).add(-1, 'month'));
        this.triggerNavigated();
    };

    DaysOfMonthCalendar.prototype.next = function () {
        this.open(moment(this.date).add(1, 'month'));
        this.triggerNavigated();
    };

    DaysOfMonthCalendar.prototype.open = function (date) {
        this.date = date;
        this.rerender();
    };

    DaysOfMonthCalendar.prototype.rerender = function () {
        this.updateTitle();
        this.buildDays();
        this.renderDaysInRowsOfSeven();
    };

    DaysOfMonthCalendar.prototype.updateTitle = function () {
        var title = globalize.format(
            this.date.toDate(),
            this.options.titleFormat,
            this.options.languageISOCode ? this.options.languageISOCode : undefined);
        this.$title.text(title);
    };

    DaysOfMonthCalendar.prototype.getOpenDate = function () {
        return this.date;
    };

    DaysOfMonthCalendar.prototype.buildDays = function () {
        this.days = [];

        var start = moment(this.date)
            .startOf('month')
            .startOf('isoWeek')
            .startOf('day');

        // Always show 6 weeks. This is the only way to make sure the calendar always has the same size.
        var stop = moment(start)
            .add(5, 'weeks')
            .endOf('isoWeek')
            .startOf('day');

        while (start.isBefore(stop, 'day') || start.isSame(stop, 'day')) {
            var date = moment(start);
            var day = this.createDay(date);
            this.days.push(day);

            start.add(1, 'days');
        }
    };

    DaysOfMonthCalendar.prototype.createDay = function(date) {
        var $day = $('<div />')
            .text(globalize.format(date.toDate(), ' d'));
        var today = moment();

        if (date.isSame(this.date, 'month')) {
            $day.addClass('this-month');

            if (this.isWeekend(date))
                $day.addClass('weekend');

            if (date.isSame(today, 'day'))
                $day.addClass('today');

            if (this.selectedDate && date.isSame(this.selectedDate, 'day'))
                $day.addClass('selected');

            if (this.hasClickedListeners()) {
                var self = this;
                $day
                    .addClass('clickable')
                    .on('click', function () {
                        if (self.isSelectedDate(date))
                            return;
                        self.setSelectedDate(date);
                        self.triggerClicked(date);
                    });
            }
        } else {
            $day.addClass('another-month');
        }

        return {
            $element: $day,
            moment: date
        };
    };

    DaysOfMonthCalendar.prototype.isWeekend = function (date) {
        var dayOfWeek = date.isoWeekday();
        return dayOfWeek === 6 || dayOfWeek === 7;
    };

    DaysOfMonthCalendar.prototype.isSelectedDate = function(otherDate) {
        return this.selectedDate && this.selectedDate.isSame(otherDate);
    };

    DaysOfMonthCalendar.prototype.renderDaysInRowsOfSeven = function () {
        this.$days
            .children(':not(.weekday-headers)')
            .remove();

        var $days = _.pluck(this.days, '$element');

        while ($days.length) {
            var $row = $days.splice(0, 7);
            this.$days
                .append($('<div />')
                    .addClass('days-of-month')
                    .append($row));
        }
    };

    DaysOfMonthCalendar.prototype.decorateDate = function (date, backgroundColor, fontColor, tooltip, isUnavailable) {
        var visibleDay = this.getDay(date);

        if (visibleDay) {
            if (isUnavailable) {
                visibleDay.$element
                    .addClass('unavailable')
                    .removeClass('clickable')
                    .off('click');
            }

            // in case of the colors, the last one will win
            if (backgroundColor)
                visibleDay.$element.css('background-color', backgroundColor);

            if (fontColor)
                visibleDay.$element.css('color', fontColor);

            // in case of the tooltip we will merge the text if there are multiple events for the same date
            if (tooltip) {
                var title = visibleDay.$element.attr('title');

                if (title)
                    title = title + '\n' + tooltip;
                else
                    title = tooltip;

                visibleDay.$element.attr('title', html.strip(title));
            }
        }
    };

    DaysOfMonthCalendar.prototype.setSelectedDate = function (date) {
        this.clearSelectedDate();

        var visibleDay = this.getDay(date);
        if (visibleDay)
            visibleDay.$element.addClass('selected');

        this.selectedDate = date;
    };

    DaysOfMonthCalendar.prototype.clearSelectedDate = function () {
        if (!this.selectedDate)
            return;

        var visibleDay = this.getDay(this.selectedDate);
        if (visibleDay)
            visibleDay.$element.removeClass('selected');

        this.selectedDate = null;
    };

    DaysOfMonthCalendar.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    DaysOfMonthCalendar.prototype.getDay = function (date) {
        return _.find(this.days, function (day) {
            return day.moment.isSame(date, 'day');
        });
    };

    DaysOfMonthCalendar.prototype.set = function (option, value) {
        if (!this.options.hasOwnProperty(option))
            return;

        this.options[option] = value;

        if (option === 'titleFormat')
            this.updateTitle();
        else if (option === 'showWeekdayHeaders')
            this.toggleWeekdayHeaders();
        else if (option === 'weekdayHeadersFormat')
            this.updateWeekdayHeaders();
    };

    return DaysOfMonthCalendar;


});
